<template>
  <a-modal :open="visible" @ok="ok" @cancel="cancel" width="40%">
    <a-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <form-input
        label="系统名称"
        name="menuName"
        v-model:value="formData.menuName"
      ></form-input>
      <form-input
        label="系统英文"
        name="menuNameEn"
        v-model:value="formData.menuNameEn"
      ></form-input>
      <form-input
        label="系统三字码"
        name="menuCode"
        v-model:value="formData.menuCode"
      ></form-input>
      <form-input
        label="系统域名"
        name="menuPath"
        v-model:value="formData.menuPath"
      ></form-input>
      <a-form-item
        v-if="formData.menuPath"
        label="集成模式"
        name="integrationMode"
      >
        <a-select v-model:value="formData.integrationMode" placeholder="请选择">
          <a-select-option value="mfe">微前端</a-select-option>
          <a-select-option value="iframe">Iframe</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        v-if="formData.menuPath && formData.integrationMode === 'mfe'"
        label="是否灰度"
        name="isGray"
      >
        <a-radio-group v-model:value="formData.isGray">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-item>
      <form-input
        type="textarea"
        label="系统描述"
        name="menuDesc"
        :rows="6"
        v-model:value="formData.menuDesc"
      ></form-input>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue'
import { inject, toRefs, reactive, ref, watch } from 'vue'
import { menu_system_operate_post } from 'server/modules/351.js'
import useAPI from 'UseApi'
export default {
  setup() {
    const systemState = inject('systemState')
    let oldFormData = null
    const formRef = ref()
    const APIS = useAPI(null, [4231])
    const { trackLetter } = APIS.v1_station_letter_create_post_()
    // 上报站内信
    const trackMessage = () => {
      const params = systemState.formData
      if (params.id && oldFormData.menuName !== params.menuName) {
        trackLetter({
          title: '更新系统',
          type: 1,
          message: `将<span style="color:#1890FF">${oldFormData.menuName}</span>为<span style="color:#1890FF">${params.menuName}</span>`
        })
      } else if (!params.id) {
        trackLetter({
          title: '创建系统',
          type: 1,
          message: `创建了<span style="color:#1890FF">${params.menuName}</span>`
        })
      }
    }
    const alertState = reactive({
      cancel() {
        const { setAttrs, setEmpty } = systemState
        setAttrs('visible', false)
        setEmpty()
      },
      ok: async () => {
        formRef.value
          .validate()
          .then(() => {
            alertState.add()
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      add: async () => {
        const { success, retInfo } = await menu_system_operate_post(
          systemState.formData,
          oldFormData
        ).catch(() => {})
        if (success) {
          systemState.getSystemList()
          trackMessage()
          alertState.cancel()
          message.info(retInfo)
        } else {
          message.error(retInfo)
        }
      }
    })
    const rules = {
      menuName: [
        {
          required: true,
          message: '必填',
          trigger: 'blur'
        }
      ],
      menuNameEn: [
        {
          required: true,
          message: '必填',
          trigger: 'blur'
        }
      ],
      menuDesc: [{ required: true, message: '必填', trigger: 'blur' }],
      menuCode: [{ required: true, message: '必填', trigger: 'blur' }]
    }
    watch(
      () => systemState.visible,
      val => {
        if (val && systemState.formData.id) {
          oldFormData = JSON.parse(JSON.stringify(systemState.formData))
        }
      },
      {
        immediate: true
      }
    )

    return {
      formRef,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rules,
      ...toRefs(alertState),
      ...toRefs(systemState)
    }
  }
}
</script>
